BPLibs = {
  types: {},
  instantiators: {},
};

require("./breakOn.js");
require("./ieFixer.js");
require("./system.js");
require("./helpers.js");
require("./resourceManager.js");
require("./SlotMachine/Injector.js");
require("./SlotMachine/PreInjector.js");
require("./SlotMachine/PostInjector.js");
require("./SlotMachine/DynamicInjector.js");
require("./SlotMachine/infiniReel.js");
require("./SlotMachine/groupAnalyser.js");
require("./SlotMachine/slotMachine.js");
require("./autoplayManager.js");
require("./console.js");
require("./interpolationHelper.js");
require("./layoutController.js");
require("./layoutPanel.js");
require("./loader.js");
require("./meter.js");
require("./okBox.js");
require("./reel.js");
require("./reelManager.js");
require("./reelAnimation.js");
require("./reelBoxStrip.js");
require("./skinnedBox.js");
require("./soundManager.js");
require("./demoManager.js");
require("./tabbedDemoManager.js");
require("./stakeSelectionPopup.js");
require("./standardObjectFactory.js");
require("./standardSymbolAnimations.js");
require("./standardWinlineAnimations.js");
require("./streamedVideoPanel.js");
require("./systemOverlay.js");
require("./textureParser.js");
require("./timer.js");
require("./touchAreaManager.js");
require("./transitionManager.js");
require("./winlineAnimationController.js");
require("./winlineBatcher.js");
require("./winlineManager.js");
require("./yesNoBox.js");
require("./Controllers/AnimationController.js");
require("./Controllers/AutoplayController.js");
require("./Controllers/StakeController.js");
require("./Controllers/RecoveryController.js");
require("./Input/inputOverlord.js");
require("./Input/inputHelpers.js");
require("./Input/autoplayButton.js");
require("./Input/autoplayCancelButton.js");
require("./Input/optionsButton.js");
require("./Input/stakeButton.js");
require("./Input/gameRulesButton.js");
require("./Input/homeButton.js");
require("./Input/volumeButton.js");
require("./Input/spinButton.js");
require("./Input/slamStopButton.js");
require("./Input/skipWinsButton.js");
require("./Input/turboButton.js");
require("./Input/buttonGroup.js");
require("./Input/helpPageClosebutton.js");
require("./Input/helpPageNextbutton.js");
require("./Input/helpPagePrevbutton.js");
require("./StateMachine/StateMachine.js");
require("./StateMachine/StatePhase.js");
require("./helpPageManager.js");
require("./htmlViewer.js");
require("./soundTracker.js");
require("./particleManager.js");
require("./weightedTable.js");
BPLibs.instantiators["ControlledObject"] = require("./ControlledObject.js");
require("./SlotsEngine/includes.js");
